import { SVGProps } from "react";

export const DollarIcon = ({
  color = "currentColor",
  size = 16,
  strokeWidth = 1,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg fill="none" viewBox="0 0 24 24" width={size} height={size} {...rest}>
      <path
        stroke={color}
        strokeWidth={strokeWidth}
        d="M6 16v3.5S8 21 12 21m6 -13V4.5S16 3 12 3m0 0C8 3 6 4.5 6 4.5l0 5.526 12 3.948 0 5.526S16 21 12 21m0 -18 0 -3m0 21 0 3"
      />
    </svg>
  );

  return render();
};
